import PropTypes from 'prop-types'

const ChevronDown = ({
  width = 14,
  height = 14,
  color = '#5A5555',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Icon">
      <path
        id="Vector"
        d="M5 5.25L7.5 7.75L10 5.25"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)

ChevronDown.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
}

export default ChevronDown
